module.exports = __webpack_public_path__ + "img/neotag_unit_yellow-01.11bf58c1.svg";